import React from 'react';

const Input = (props) => {
  const className = 'form-group text-left' + (props.className || ' ') +
      (props.showRequired ? 'required' : props.showError ? 'error' : '');

    return (
      <div className={className}>
        <label className="control-label white" htmlFor={props.name}>{props.title} <span className="white">{props.asterix}</span></label>
        <input
          type={props.type || 'text'}
          name={props.name}
          onChange={props.changeValue}
          value={props.value}
          className='form-control input-sm'
        />
        {props.errorMessage && <div className="validation-error">{props.errorMessage}</div>}
      </div>
    );
};

export default Input;



// WEBPACK FOOTER //
// ./src/components/Input.js